module.exports = __webpack_public_path__ + "img/team-2.36fb2c42.jpg";